export default __webpack_public_path__ + "static/media/push6.2fbefd40.gif";